export default function getDataExportPrice(sState, params, sDispatch, pricingid, companyType) {
    
    const abortController = new AbortController();

      //console.log("uid: "+sState.userid+", aid:"+sState.aid+", geom:"+sState.datageom.area);
      const request = {
        userid: sState.userid,
        accountid: sState.aid,
        ident: sState.ident,
        companytype: companyType,
        pricingid: pricingid,
        fixedsize: params.fixedsize,
        fixedprice: params.fixedprice,
        geometry: sState.datageom.geometry,
        area: sState.datageom.area,
      }

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/export/price', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            sDispatch({
              type: "setexportListPrice",
              payload: { exportListPrice: data.data}
            });
          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
}